var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigningContractPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68712 20.25C4.57837 20.25 4.46813 20.2264 4.36388 20.1761C3.85725 19.9339 3 19.1576 3 17.7859C3 16.3586 4.07625 15.099 4.86263 14.1795L5.06813 13.938C5.322 13.6373 5.3625 13.2371 5.16937 12.9428C4.566 12.0221 4.48613 10.971 4.94513 9.98251C5.92613 7.87013 9.93637 5.32613 13.701 4.42688C14.103 4.33201 14.5084 4.57913 14.6047 4.98188C14.7011 5.38501 14.4525 5.78926 14.0497 5.88563C10.1835 6.80888 6.93375 9.26213 6.30563 10.6144C6.06338 11.1364 6.102 11.6291 6.42413 12.1204C6.984 12.9743 6.9 14.0936 6.2145 14.9055L6.003 15.1541C5.33325 15.9375 4.5 16.9125 4.5 17.7859C4.5 18.5573 5.00625 18.8213 5.01112 18.8239C5.385 19.0028 5.54288 19.4505 5.36363 19.824C5.235 20.0929 4.9665 20.25 4.68712 20.25ZM16.2908 7.94813L18.6772 10.3346L10.2971 18.714L7.16025 20.2181C6.6945 20.3741 6.25087 19.9305 6.4065 19.4644L7.91062 16.3275L16.2908 7.94813ZM17.2549 6.98401L18.789 5.44988C19.0553 5.18363 19.4869 5.18363 19.7531 5.44988L21.1751 6.87188C21.4414 7.13813 21.4414 7.56976 21.1751 7.83601L19.641 9.37013L17.2549 6.98401Z",
    fill: "#F8009E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigningContractPen);
export default __webpack_public_path__ + "static/media/SigningContractPen.e237ceca5e29776dfdb9af23d40d6d77.svg";
export { ForwardRef as ReactComponent };